import { Box, Typography, styled, useTheme } from "@mui/material";
import { Down, Up } from "assets/Icon";
import React, { useMemo } from "react";

function StockNumber({
  value,
  hasArrows,
  variant = "h6",
  isBoxView,
  ...props
}) {
  const theme = useTheme();
  const isPositive = value > 0;
  const isZero = value === 0;

  const textColor = useMemo(() => {
    if (isZero) {
      return "text.main";
    }

    if (isPositive) {
      return "success.main";
    }

    return "error.main";
  }, [isZero, isPositive]);

  const boxColor = useMemo(() => {
    if (isZero) {
      return theme.palette.background.lightest;
    }

    if (isPositive) {
      return theme.palette.success.main;
    }

    return theme.palette.error.main;

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isZero, isPositive]);

  const stockIcon = useMemo(() => {
    if (isZero) {
      return "";
    }

    if (isPositive) {
      return (
        <Up
          color={
            isBoxView ? theme.palette.text.main : theme.palette.success.main
          }
        />
      );
    }

    return (
      <Down
        color={isBoxView ? theme.palette.text.main : theme.palette.error.main}
      />
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPositive, isZero]);

  return (
    <BoxStyle
      isBoxView={isBoxView}
      boxColor={boxColor}
      {...props}
      display="flex"
      alignItems="center"
    >
      <Typography
        component="span"
        variant={variant}
        color={textColor}
        minWidth={!isBoxView && "56px"}
      >
        {isPositive > 0 && "+"}
        {value}%
      </Typography>{" "}
      <Typography
        display="flex"
        alignItems="center"
        justifyContent="center"
        component="span"
      >
        {hasArrows && stockIcon}
      </Typography>
    </BoxStyle>
  );
}

const BoxStyle = styled(Box)(({ isBoxView, boxColor, theme }) => ({
  borderRadius: isBoxView && "8px",
  background: isBoxView ? boxColor : "transparent",
  display: isBoxView && "flex",
  alignItems: isBoxView && "center",
  justifyContent: isBoxView && "center",
  minHeight: isBoxView && "30px",

  ".MuiTypography-root": {
    color: isBoxView && theme.palette.common.white,
  },
}));

export default StockNumber;
